import { useCallback } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import { notificationsStore, type NotificationsStoreState } from './NotificationsStore';
import { selectData, selectById } from '../selectors.ts';
import { useAttach } from '../useAttach';

export function useNotificationsData() {
  useAttach(notificationsStore, 'useNotificationsData');
  return useStoreWithEqualityFn(notificationsStore.store, selectData, shallow);
}
useNotificationsData.store = notificationsStore;

export function useNotificationsById() {
  useAttach(notificationsStore, 'useNotificationsById');
  return useStoreWithEqualityFn(notificationsStore.store, selectById, shallow);
}
useNotificationsById.store = notificationsStore;

export function useNotification({ notificationId }: { notificationId: string }) {
  useAttach(notificationsStore, 'useNotification');

  const select = useCallback(
    (state: NotificationsStoreState) => {
      return {
        notification: state.byId?.[notificationId] ?? null,
        notificationInstance: state.data?.[notificationId] ?? null,
      };
    },
    [notificationId]
  );

  return useStoreWithEqualityFn(notificationsStore.store, select, shallow);
}
useNotification.store = notificationsStore;

export function useNotificationsAttach() {
  useAttach(notificationsStore, 'useNotificationsAttach');
}
useNotificationsAttach.store = notificationsStore;
